import {nMonthsAgo} from "./utils/date";
import {DocumentGrouping, KeyFigureCode, ReportDefinition, TimePeriodCode} from "./utils/type";
import {
  DNB_BANKKONTOUTDRAG,
  DNB_BEHOLDNING_AGGREGERT,
  DNB_CONTRACT_NOTES,
  DNB_REALIZED_PROFITS,
  DNB_TRANSAKSJONSOVERSIKT_TOT_NEW,
  DNB_TRANSAKSJONSRAPPORT_TOT_EXCEL_NEW,
  DNB_UTVIKLING_OG_HISTORISK_VERDI
} from "./utils/reportDefinitions";

const {NODE_ENV} = process.env;

export const isDevelopment = NODE_ENV === "development";
export const API_URL = window.location.origin;

interface PerformanceCardTimePeriod {
  code: TimePeriodCode;
  type: "absolute" | "relative" | "both";
}

export const config = {
  general: {
    companyName: "Pensum Asset Management",
    useProfitAndLoss: false,
  },
  overviewPage: {
    showAdvisor: false,
    showPieCharts: true,
    defaultTimePeriodCode: "CALYEAR-0" as TimePeriodCode,
    timePeriodCodes: [
      "MONTHS-1",
      "MONTHS-3",
      "MONTHS-6",
      "CALYEAR-0",
      "YEARS-1",
      "YEARS-3",
      "GIVEN",
    ] as TimePeriodCode[],
    performanceCardTimePeriodCodes: [
      {code: "GIVEN", type: "both"},
      {code: "CALYEAR-0", type: "both"}
    ] as PerformanceCardTimePeriod[]
  },
  portfolioPage: {
    showKID: false,
    showCashBalance: false,
    showUnderlyingFee: false,
    showPieCharts: true,
    performanceCardTimePeriodCodes: [
      {code: "GIVEN", type: "both"},
      {code: "CALYEAR-0", type: "both"},
    ] as PerformanceCardTimePeriod[],
    showCreditAccountDetails: true,
    keyFiguresToShow: [] as KeyFigureCode[],
    depositAndWithdrawal: {
      showDepositAndWithdrawal: false,
      depositTag: "deposit-waiting",
      withdrawalTag: "withdrawal-waiting",
    },
    defaultTimePeriodCode: "CALYEAR-0" as TimePeriodCode,
    timePeriodCodes: [
      "MONTHS-1",
      "MONTHS-3",
      "MONTHS-6",
      "CALYEAR-0",
      "YEARS-1",
      "YEARS-3",
      "GIVEN",
    ] as TimePeriodCode[],
    portfolioList: {
      timePeriodCodes: [
        "MONTHS-1",
        "MONTHS-3",
        "MONTHS-6",
        "CALYEAR-0",
        "YEARS-1",
        "GIVEN",
      ] as TimePeriodCode[],
      portfolioStatusesToToggle: ["P", "C"],
    },
  },
  transactionsPage: {
    includeTradeOrders: false,
  },
  costsPage: {
    showCostsPage: true,
    timePeriods: [
      {code: "MONTHS-1" as TimePeriodCode, startDate: nMonthsAgo(1)},
      {code: "MONTHS-3" as TimePeriodCode, startDate: nMonthsAgo(3)},
      {code: "MONTHS-6" as TimePeriodCode, startDate: nMonthsAgo(6)},
      {
        code: "CALYEAR-0" as TimePeriodCode,
        startDate: new Date(new Date().getFullYear(), 0, 1),
      },
    ],
  },
  components: {
    securityDetails: {
      showFlags: true,
      defaultTimePeriodCode: "CALYEAR-0" as TimePeriodCode,
      timePeriodCodes: [
        "MONTHS-1",
        "MONTHS-3",
        "CALYEAR-0",
        "YEARS-1",
        "YEARS-3",
        "YEARS-5"
      ] as TimePeriodCode[],
    },
  },
  tradingPage: {
    showTradingPage: false,
    tradeableSecuritiesTags: [],
    fxMargin: 1.01,
    minInvestmentAmount: 1000
  },
  advisorPage: {
    showAdvisorPage: true,
    representativesToExclude: [10830, 9711, 8980, 7780, 8, 6, 127, 4293, 4451, 7436],
    showSavingsColumn: false,
    useAdvisorSplit: true,
    canUploadDocument: true,
    showDepositButton: false
  },
  savingsPage: {
    showSavingsPage: false,
    availableSavingsDates: [1, 10, 15, 20, 25],
    minSavingsPlanAmount: 500,
    minInvestmentAmountPerSavingItem: 100,
    maxNumberOfSecurities: 10,
  },
  securityDetailsPage: {
    showOngoingCosts: false,
    showManagementFee: false,
    showMinTradeAmount: false,
    showMorningstarRating: true,
    showSRRI: true,
    showSecurityDocuments: false,
    showFundDetails: true,
    showTopHoldings: true,
    showSectorAllocations: true,
    showGeographicAllocations: true,
    showSfdr: true,
    showFundDocumentsCard: false
  },
  documentsPage: {
    documentGrouping: [
      {
        pattern: /\bMNDrapport\b/i,
        label: "Månedsrapporter",
      },
      {
        pattern: /\b(skatt\d{4}|tax)\b/i,
        label: "Skattedokumenter",
      },
      {
        pattern: /\bavtaler\b/i,
        label: "Avtaledokumenter",
      },
    ] as DocumentGrouping[],
    reports: [
      DNB_UTVIKLING_OG_HISTORISK_VERDI,
      DNB_REALIZED_PROFITS,
      DNB_BANKKONTOUTDRAG,
      DNB_CONTRACT_NOTES,
      DNB_BEHOLDNING_AGGREGERT,
      DNB_TRANSAKSJONSRAPPORT_TOT_EXCEL_NEW,
      DNB_TRANSAKSJONSOVERSIKT_TOT_NEW
    ] as ReportDefinition[],
  }
};
